import scbiLogo from './assets/logo_scbi.png';
import agencySeal from './assets/logo_agence_round.png';
import agencyBuilding from './assets/agency_building.jpg';

export const COLORS = {
    primary: '#EA723D', // Orange Borbiconi
    secondary: '#2C353D', // Charbon Borbiconi
    text: '#333333',
    lightGray: '#F5F5F5',
    white: '#FFFFFF'
};

export const AGENCY_INFO = {
    name: "Borbiconi Immobilier",
    tagline: "L'Immobilier frontalier !",
    phone: "03 82 82 35 69",
    email: "contact@scbi.fr",
    address: "38 rue Principale, 57840 Ottange",
    sector: "Ottange & Secteur Frontalier",
    photo: agencyBuilding,
    facebookPage: "https://www.facebook.com/borbiconiimmobilier",
    instagram: "https://www.instagram.com/borbiconiimmobilier/"
};

// For backward compatibility with components expecting AGENT_INFO
export const AGENT_INFO = {
    ...AGENCY_INFO,
    role: "Votre Agence Immobilière"
};

export const LOGO_URL = scbiLogo;
export const AGENCY_SEAL = agencySeal;

export const formatPrice = (price) => {
    if (typeof price === 'string') {
        const cleaned = Number(price.replace(/[^0-9]/g, ''));
        if (!isNaN(cleaned) && cleaned > 0) price = cleaned;
    }
    const num = Number(price) || 0;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(num);
};
